import React, { useState } from 'react';
import { currentFinancialYear, type ID } from '@hrms/shared';
import { api } from '../../../lib/api';
import { openFile } from '../../../lib/files';
import { Alert, Button, Card, PageHeader, Row, Screen, Select, Stack, Text } from '../../../ui';
import { AutoGrid, fyList, FySelect } from '../components/common';
import { EmployeePicker } from '../components/EmployeePicker';

/** Previous FY is the usual one for Form 16 (issued by 15 June after year end). */
const lastFy = () => fyList(1, false)[1] ?? currentFinancialYear();

export function Form16Screen() {
  const [emp, setEmp] = useState<ID | null>(null);
  const [fy, setFy] = useState(lastFy());
  return (
    <Screen testID="form16">
      <PageHeader title="Form 16" subtitle="Part A & B TDS certificate generated from payroll and TDS challan data." />
      <Card>
        <Stack gap={14}>
          <AutoGrid min={240}>
            <EmployeePicker label="Employee" required value={emp} onChange={setEmp} testID="form16-employee" />
            <FySelect label="Financial year" value={fy} onChange={setFy} />
          </AutoGrid>
          <Row justify="flex-end">
            <Button variant="primary" icon="eye" title="Generate Form 16" disabled={!emp} onPress={() => void openFile(api.payroll.form16Path(emp!, fy))} testID="form16-open" />
          </Row>
        </Stack>
      </Card>
      <Text variant="muted">Opens a printable HTML certificate — use Print → Save as PDF to share it.</Text>
    </Screen>
  );
}

const QUARTERS = [
  { value: 1, label: 'Q1 (Apr–Jun)' },
  { value: 2, label: 'Q2 (Jul–Sep)' },
  { value: 3, label: 'Q3 (Oct–Dec)' },
  { value: 4, label: 'Q4 (Jan–Mar) + Annexure II' },
];

export function Form24QScreen() {
  const [fy, setFy] = useState(currentFinancialYear());
  const [quarter, setQuarter] = useState(1);
  return (
    <Screen testID="form24q">
      <PageHeader title="Form 24Q" subtitle="Quarterly TDS return on salary (Annexure I; Annexure II in Q4)." />
      <Card>
        <Stack gap={14}>
          <AutoGrid min={220}>
            <FySelect label="Financial year" value={fy} onChange={setFy} />
            <Select label="Quarter" value={quarter} onChange={setQuarter} options={QUARTERS} />
          </AutoGrid>
          <Row justify="flex-end">
            <Button variant="primary" icon="download" title="Generate 24Q (CSV)" onPress={() => void openFile(api.payroll.form24qPath(fy, quarter))} testID="form24q-open" />
          </Row>
        </Stack>
      </Card>
      <Alert tone="info">Validate the generated file with the NSDL/Protean File Validation Utility before filing.</Alert>
    </Screen>
  );
}
